import React, { useEffect, useState } from 'react';

import { BiX } from 'react-icons/bi';

import Button from '../../../../newComponents/Button';

import * as S from './styles';
import { useToast } from '../../../../hooks/toast';
import Input from '../../../../newComponents/Input';
import moneyMask from '../../../../utils/moneyMask';

interface ModalCouponProps {
  onClose: () => void;
  finalPrice: number;
  handleChangeMoney: React.Dispatch<React.SetStateAction<string>>;
}

const ModalChangeMoney: React.FC<ModalCouponProps> = (props) => {
  const { onClose, finalPrice, handleChangeMoney } = props;

  const { addToast } = useToast();

  const [changeMoney, setChangeMoney] = useState('R$ 0,00');
  const [isError, setIsError] = useState(false);

  const conclusion = (): void => {
    handleChangeMoney(changeMoney);
    addToast({
      type: 'success',
      title: 'Salvo!',
    });
    onClose();
  };

  useEffect(() => {
    const changeMoneyNumber = +changeMoney
      .replace('.', '')
      .replace(',', '.')
      .replace('R$', '')
      .trim();

    if (changeMoneyNumber > 0 && finalPrice > changeMoneyNumber)
      setIsError(true);
    else setIsError(false);
  }, [changeMoney, finalPrice]);

  return (
    <S.CustomModal open onClose={onClose} closeAfterTransition>
      <div className="body">
        <S.ModalHeader>
          <h1>Troco para quanto?</h1>
          <button type="button" onClick={onClose}>
            <BiX />
          </button>
        </S.ModalHeader>

        <S.ModalBody>
          <Input
            placeholder="Ex.: 25,50"
            value={changeMoney}
            onChange={(event) => {
              const { value } = event.target;
              setChangeMoney(moneyMask(value));
            }}
            error={isError ? 'Valor inferior ao total' : undefined}
          />
        </S.ModalBody>

        <S.ModalFooter>
          <Button full onClick={conclusion} disabled={isError}>
            Concluir
          </Button>
          <Button full variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
        </S.ModalFooter>
      </div>
    </S.CustomModal>
  );
};

export default ModalChangeMoney;
